import DisclosureView from '@/views/DisclosureView.vue';
import { createPage } from './createPage';

// Точка входа страницы «Раскрытие информации» — disclosure.html
createPage(DisclosureView, 'disclosure');
